import React, { useMemo } from "react";
import "./CreditorColor.scss";
import { ConnectedProps, connect } from "react-redux";
import Common from "us.common";
import { RootState } from "us.helper/types";
import { CreditorColors } from "us.collection.case/constants";

const { $Tag } = Common.Components;

const CreditorColor: React.FC<PropsFromRedux> = (props) => {
  const { metaData } = props;
  const { creditorColor, creditorColorDescription } = metaData.data ?? {};
  const isVisible = useMemo(() => {
    return (
      creditorColor?.trim() && creditorColor != CreditorColors.DEFAULT
    );
  }, [creditorColor]);
  return (
    <>
      {isVisible && (
        <div
          className="creditor-color"
          style={{ borderColor: `#${creditorColor}` }}
        >
          {creditorColorDescription && (
            <$Tag color={`#${creditorColor}`}>{creditorColorDescription}</$Tag>
          )}
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: RootState) => {
  const { domainView } = state;
  const { metaData } = domainView;
  return {
    metaData,
  };
};
const mapDispatchToProps = {};
const connector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;
export default connector(CreditorColor);
